 // adding the colors array as reference
const colorArray = [
  { "id": 1, "color": "Ivory-Ivory" },
  { "id": 2, "color": "Ivory-Champagne" },
  { "id": 3, "color": "Ivory-Nude" },
  { "id": 4, "color": "Ivory" },
  { "id": 5, "color": "Ivory-Ivory" },
  { "id": 12, "color": "Off White" },
  { "id": 13, "color": "All Ivory" },
  { "id": 14, "color": "Ivory" },
  { "id": 15, "color": "Ice Blue" },
  { "id": 16, "color": "L. Ivory" },
  { "id": 17, "color": "Sand" },
  { "id": 18, "color": "All Ivory" },
  { "id": 19, "color": "Dress Ivory + V Insert Nude" },
  { "id": 20, "color": "Nude Top + Ivory Skirt" },
  { "id": 21, "color": "Nude" },
  { "id": 22, "color": "Champagne" },
  { "id": 23, "color": "Nude Bodice + Ivory Skirt" },
  { "id": 24, "color": "Light Blush" },
  { "id": 25, "color": "Nude Top + Light Blush Skirt" },
  { "id": 26, "color": "Ice Pink" },
  { "id": 27, "color": "Full Ivory" },
  { "id": 28, "color": "Nude / Light Blush" },
  { "id": 29, "color": "Blush" },
  { "id": 30, "color": "Ivory Champagne" },
  { "id": 31, "color": "Ivory / Nude" },
  { "id": 32, "color": "Off White" },
  { "id": 33, "color": "Custom / Bespoke" },
  { "id": 34, "color": "Silver" },
  { "id": 35, "color": "Ivory / Light Nude" },
  { "id": 36, "color": "Black" },
  { "id": 37, "color": "Ivory / Champagne" },
  { "id": 38, "color": "Gold" }
]

const sizeArray = [
  { "id": 1, "size": "28" },
  { "id": 2, "size": "26" },
  { "id": 3, "size": "24" },
  { "id": 4, "size": "22" },
  { "id": 5, "size": "20" },
  { "id": 6, "size": "18" },
  { "id": 7, "size": "16" },
  { "id": 8, "size": "14" },
  { "id": 9, "size": "12" },
  { "id": 10, "size": "10" },
  { "id": 11, "size": "8" },
  { "id": 12, "size": "6" },
  { "id": 13, "size": "4" },
  { "id": 14, "size": "2" },
  { "id": 15, "size": "0" },
  { "id": 59, "size": "0" },
  { "id": 60, "size": "2" },
  { "id": 61, "size": "4" },
  { "id": 62, "size": "6" },
  { "id": 63, "size": "8" },
  { "id": 64, "size": "10" },
  { "id": 65, "size": "12" },
  { "id": 66, "size": "14" },
  { "id": 67, "size": "16" },
  { "id": 68, "size": "18" },
  { "id": 69, "size": "20" },
  { "id": 70, "size": "22" },
  { "id": 71, "size": "24" },
  { "id": 72, "size": "26" },
  { "id": 73, "size": "28" },
  { "id": 74, "size": "0" },
  { "id": 75, "size": "2" },
  { "id": 76, "size": "4" },
  { "id": 77, "size": "6" },
  { "id": 78, "size": "8" },
  { "id": 79, "size": "10" },
  { "id": 80, "size": "12" },
  { "id": 81, "size": "14" },
  { "id": 82, "size": "16" },
  { "id": 83, "size": "18" },
  { "id": 84, "size": "20" },
  { "id": 85, "size": "22" },
  { "id": 86, "size": "24" },
  { "id": 87, "size": "26" },
  { "id": 88, "size": "28" }
]

// adding a function to fetch a color
export function getColorById(id) {
  const item = colorArray.find(obj => obj.id === id);
  return item ? item.color : null; // returns the color if found, else null
}

export function getSizeById(id) {
  const item = sizeArray.find(obj => obj.id === id);
  return item ? item.size : null; // returns the size if found, else null
}